"use client";

import { c as _c } from "react/compiler-runtime";
import { useJwtToken } from "@website/hooks/auth-manager";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { isChannel } from "@website/utils/channel/helpers";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { useLoginModal } from "@website/widget/login";
import { useEffect } from "react";
export const WelcomeScreenClientHandler = () => {
  const $ = _c(6);
  const {
    onLoginModalOpen
  } = useLoginModal();
  const router = useCompatRouter();
  const {
    phoneNumber
  } = useJwtToken();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopping", "checkout", "profile"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const shouldNotShowPaths = t0;
  let t1;
  if ($[1] !== onLoginModalOpen || $[2] !== phoneNumber || $[3] !== router?.pathname) {
    t1 = () => {
      const raw = localStorage.getItem("lastTimeWelcomeScreenShowed");
      const lastShow = raw ? new Date(raw).getTime() : 0;
      const diffSec = (Date.now() - lastShow) / 1000;
      if (diffSec >= 86400 && !phoneNumber && isChannel(["android"]) && shouldNotShowPaths.every(path => !router?.pathname?.includes(path))) {
        addEventToTracking(USER_TRACKING_EVENTS.APP_WELCOME_SCREEN_SHOWED, {
          product: "core"
        });
        let lastShowTimeout;
        const welcomeTimeout = setTimeout(() => {
          onLoginModalOpen({
            isWelcomeScreen: true
          });
          lastShowTimeout = setTimeout(_temp, 100);
        });
        return () => {
          clearTimeout(welcomeTimeout);
          if (lastShowTimeout) {
            clearTimeout(lastShowTimeout);
          }
        };
      }
    };
    $[1] = onLoginModalOpen;
    $[2] = phoneNumber;
    $[3] = router?.pathname;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  return null;
};
function _temp() {
  localStorage.setItem("lastTimeWelcomeScreenShowed", new Date().toISOString());
}